var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe02(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.0002 5.33337C38.6702 12.6356 42.4608 22.1121 42.6668 32C42.4608 41.888 38.6702 51.3644 32.0002 58.6667M32.0002 5.33337C25.3301 12.6356 21.5395 22.1121 21.3335 32C21.5395 41.888 25.3301 51.3644 32.0002 58.6667M32.0002 5.33337C17.2726 5.33337 5.3335 17.2724 5.3335 32C5.3335 46.7276 17.2726 58.6667 32.0002 58.6667M32.0002 5.33337C46.7278 5.33337 58.6668 17.2724 58.6668 32C58.6668 46.7276 46.7278 58.6667 32.0002 58.6667M6.66688 24H57.3335M6.66683 40H57.3335",
    stroke: "#414651",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe02);
export default __webpack_public_path__ + "static/media/globe-02.164b5561a0c6b8e03214e8996708ff9d.svg";
export { ForwardRef as ReactComponent };